import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import "./form-field/styles.scss";

/*
  Drop-in formik replacement for the redux-form FormField wrapper.
  Mirrors the exact DOM structure of components/forms/form-field/index.jsx
  so the existing .form-field grid CSS (label + error + input) renders correctly.
*/
const FormikFormField = ({
  name,
  label,
  labelStyle,
  type = "text",
  placeholder,
  component,
  children,
  className,
  style,
  ...props
}) => {
  const [field, meta] = useField(name);
  const error = meta.error;
  const hasError = typeof error === "string";

  const inputProps = {
    ...props,
    ...field,
    type,
    placeholder,
    id: name,
    style,
    className: `input-field ${hasError ? "has-error" : ""} ${className || ""}`.trim(),
    title: hasError && !label ? error : ""
  };

  let inputEl;
  if (component === "select") {
    inputEl = <select {...inputProps}>{children}</select>;
  } else if (typeof component === "function") {
    const C = component;
    inputEl = <C {...inputProps}>{children}</C>;
  } else {
    inputEl = <input {...inputProps} />;
  }

  return (
    <span className="form-field">
      {label && (
        <label
          className="form-field-label"
          htmlFor={name}
          style={labelStyle}
        >
          {label}
        </label>
      )}
      {hasError && <span className="form-field-error">{error}</span>}
      {inputEl}
    </span>
  );
};

FormikFormField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelStyle: PropTypes.object,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
};

export default FormikFormField;
